// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VeriSavedContainerCancel {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7019607843);
  backdrop-filter: blur(3px);
  z-index: 1400;
  color: var(--TextColor);
}
.VeriSavedContainerCancel .VeriSaved {
  padding: 1.25rem 3.75rem;
  background: var(--Background);
  border-radius: 0.375rem;
  max-width: 37.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
}
.VeriSavedContainerCancel .VeriSaved .SuccessBeginVerification {
  max-width: 18.75rem;
  max-height: 18.75rem;
}
.VeriSavedContainerCancel .VeriSaved .SuccessBeginVerification img {
  width: 100%;
  height: 100%;
}
.VeriSavedContainerCancel .VeriSaved h1 {
  font-size: 1.125rem;
  font-weight: 700;
}
.VeriSavedContainerCancel .VeriSaved .Hint {
  font-size: 0.875rem;
  text-align: center;
}
.VeriSavedContainerCancel .VeriSaved .ButtonContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 2.5rem;
}
.VeriSavedContainerCancel .VeriSaved .ButtonContainer .Cancel {
  font-size: 0.875rem;
  height: 2.5rem;
  width: 9.375rem;
  color: #979797;
  border: 0.0625rem solid #979797;
  border-radius: 0.5rem;
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
}
.VeriSavedContainerCancel .VeriSaved .ButtonContainer .Cancel:hover {
  color: var(--AccentColor);
  border: 0.0625rem solid var(--AccentColor);
  transition: all 0.3s ease;
}
.VeriSavedContainerCancel .VeriSaved .ButtonContainer .Done {
  font-size: 0.875rem;
  height: 2.5rem;
  width: 9.375rem;
  color: var(--Background);
  border: 0.0625rem solid var(--AccentColor);
  border-radius: 0.5rem;
  background: var(--AccentColor);
  border: 0.0625rem solid var(--AccentColor);
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/Components/CandidateDetails/Actions/ConfirmationModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uCAAA;EACA,0BAAA;EACA,aAAA;EACA,uBAAA;AACF;AAAE;EACE,wBAAA;EACA,6BAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AAEJ;AADI;EACE,mBAAA;EACA,oBAAA;AAGN;AAFM;EACE,WAAA;EACA,YAAA;AAIR;AADI;EACE,mBAAA;EACA,gBAAA;AAGN;AADI;EACE,mBAAA;EACA,kBAAA;AAGN;AADI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAGN;AAFM;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,+BAAA;EACA,qBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;AAIR;AAFM;EACE,yBAAA;EACA,0CAAA;EACA,yBAAA;AAIR;AAFM;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,wBAAA;EACA,0CAAA;EACA,qBAAA;EACA,8BAAA;EACA,0CAAA;EACA,eAAA;AAIR","sourcesContent":[".VeriSavedContainerCancel {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #000000b3;\n  backdrop-filter: blur(3px);\n  z-index: 1400;\n  color: var(--TextColor);\n  .VeriSaved {\n    padding: 1.25rem 3.75rem;\n    background: var(--Background);\n    border-radius: 0.375rem;\n    max-width: 37.5rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1.25rem;\n    .SuccessBeginVerification {\n      max-width: 18.75rem;\n      max-height: 18.75rem;\n      img {\n        width: 100%;\n        height: 100%;\n      }\n    }\n    h1 {\n      font-size: 1.125rem;\n      font-weight: 700;\n    }\n    .Hint {\n      font-size: 0.875rem;\n      text-align: center;\n    }\n    .ButtonContainer {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      justify-content: center;\n      gap: 2.5rem;\n      .Cancel {\n        font-size: 0.875rem;\n        height: 2.5rem;\n        width: 9.375rem;\n        color: #979797;\n        border: 0.0625rem solid #979797;\n        border-radius: 0.5rem;\n        background: transparent;\n        cursor: pointer;\n        transition: all 0.3s ease;\n      }\n      .Cancel:hover {\n        color: var(--AccentColor);\n        border: 0.0625rem solid var(--AccentColor);\n        transition: all 0.3s ease;\n      }\n      .Done {\n        font-size: 0.875rem;\n        height: 2.5rem;\n        width: 9.375rem;\n        color: var(--Background);\n        border: 0.0625rem solid var(--AccentColor);\n        border-radius: 0.5rem;\n        background: var(--AccentColor);\n        border: 0.0625rem solid var(--AccentColor);\n        cursor: pointer;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
